import { useEffect, useState } from 'react';
import './ProductDetailModal.css';

const ProductDetailModal = ({ product, isOpen, onClose, addToCart, salesMode }) => {
    const [selectedMode, setSelectedMode] = useState(salesMode || 'retail');
    const [currentImageIndex, setCurrentImageIndex] = useState(0);
    const [selectedVariantId, setSelectedVariantId] = useState('');

    const variants = Array.isArray(product?.variants) ? product.variants : [];

    useEffect(() => {
        if (!isOpen || !product) return;
        setCurrentImageIndex(0);
        setSelectedMode(salesMode || 'retail');
        if (variants.length > 0) {
            setSelectedVariantId(String(variants[0].id));
        } else {
            setSelectedVariantId('');
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isOpen, product?.id, salesMode]);

    if (!isOpen || !product) return null;

    const images = product.images || [product.img];

    const selectedVariant = variants.find(v => String(v.id) === String(selectedVariantId)) || null;

    const basePrice = selectedMode === 'wholesale'
        ? (product.priceWholesale || product.price)
        : product.price;

    const variantPrice = (() => {
        if (!selectedVariant) return null;
        const raw = selectedMode === 'wholesale' ? selectedVariant.price_wholesale : selectedVariant.price_retail;
        if (raw === null || raw === undefined || raw === '') return null;
        const n = Number(raw);
        return Number.isFinite(n) ? n : null;
    })();

    const displayPrice = variantPrice !== null ? variantPrice : basePrice;

    const nextImage = () => {
        setCurrentImageIndex((prev) => (prev + 1) % images.length);
    };

    const prevImage = () => {
        setCurrentImageIndex((prev) => (prev - 1 + images.length) % images.length);
    };

    return (
        <div className="product-modal-overlay" onClick={onClose}>
            <div className="product-modal-content" onClick={(e) => e.stopPropagation()}>
                <button className="modal-close-btn" onClick={onClose}>
                    <i className="bi bi-x-lg"></i>
                </button>

                <div className="product-modal-body">
                    {/* Image Gallery */}
                    <div className="product-modal-image">
                        <img src={images[currentImageIndex]} alt={product.title} />
                        {images.length > 1 && (
                            <div className="image-controls">
                                <button onClick={prevImage} className="img-nav-btn">
                                    <i className="bi bi-chevron-left"></i>
                                </button>
                                <span className="image-counter">
                                    {currentImageIndex + 1} / {images.length}
                                </span>
                                <button onClick={nextImage} className="img-nav-btn">
                                    <i className="bi bi-chevron-right"></i>
                                </button>
                            </div>
                        )}
                    </div>

                    {/* Product Info */}
                    <div className="product-modal-info">
                        <h2 className="product-modal-title">{product.title}</h2>

                        {product.category && (
                            <span className="product-modal-category">{product.category}</span>
                        )}

                        {product.description && (
                            <p className="product-modal-description">{product.description}</p>
                        )}

                        {variants.length > 0 && (
                            <div className="modal-variant">
                                <label className="variant-label">Select Variant</label>
                                <select
                                    className="variant-select"
                                    value={selectedVariantId}
                                    onChange={(e) => setSelectedVariantId(e.target.value)}
                                >
                                    {variants.map((v) => (
                                        <option key={v.id} value={String(v.id)}>
                                            {v.name}: {v.value}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        )}

                        {/* Mode Toggle */}
                        <div className="modal-mode-toggle">
                            <button
                                className={`mode-btn ${selectedMode === 'retail' ? 'active retail' : ''}`}
                                onClick={() => setSelectedMode('retail')}
                            >
                                🛒 Retail
                            </button>
                            <button
                                className={`mode-btn ${selectedMode === 'wholesale' ? 'active wholesale' : ''}`}
                                onClick={() => setSelectedMode('wholesale')}
                            >
                                📦 Wholesale
                            </button>
                        </div>

                        {/* Pricing */}
                        <div className="modal-pricing">
                            <div className="current-price">
                                <span className="price-label">Price:</span>
                                <span className="price-value">KSh {displayPrice}</span>
                            </div>
                            {selectedMode === 'wholesale' && product.wholesaleMinQty && (
                                <p className="min-qty-note">Minimum quantity: {product.wholesaleMinQty}</p>
                            )}
                        </div>

                        {/* Reviews */}
                        {product.reviewStar && (
                            <div className="modal-reviews">
                                <div className="stars">
                                    {[...Array(5)].map((_, i) => (
                                        <i
                                            key={i}
                                            className={`bi bi-star${i < Math.floor(product.reviewStar) ? '-fill' : ''}`}
                                        ></i>
                                    ))}
                                </div>
                                <span className="review-count">({product.numperReview || 0} reviews)</span>
                            </div>
                        )}

                        {/* Add to Cart Button */}
                        <button
                            className={`modal-add-to-cart ${selectedMode === 'retail' ? 'retail-btn' : 'wholesale-btn'}`}
                            onClick={() => {
                                addToCart(product, selectedMode, selectedVariant);
                                onClose();
                            }}
                        >
                            <i className="bi bi-cart-plus"></i> Add to Cart
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ProductDetailModal;
